import react from "react";

import CalliopeStudio1 from "../images/commercials/CalliopeStudio/KIDS_BASIC_026 Large.jpeg";
import CalliopeStudio2 from "../images/commercials/CalliopeStudio/KIDS_BASIC_027 Large.jpeg";
import CalliopeStudio3 from "../images/commercials/CalliopeStudio/KIDS_BASIC_028 Large.jpeg";
import CalliopeStudio4 from "../images/commercials/CalliopeStudio/KIDS_BASIC_029 Large.jpeg";
import CalliopeStudio5 from "../images/commercials/CalliopeStudio/KIDS_BASIC_030 Large.jpeg";
import CalliopeStudio6 from "../images/commercials/CalliopeStudio/KIDS_BASIC_031 Large.jpeg";
import CalliopeStudio7 from "../images/commercials/CalliopeStudio/KIDS_BASIC_032 Large.jpeg";
import CalliopeStudio8 from "../images/commercials/CalliopeStudio/KIDS_BASIC_068 Large.jpeg";
import CalliopeStudio9 from "../images/commercials/CalliopeStudio/KIDS_BASIC_069 Large.jpeg";
import CalliopeStudio10 from "../images/commercials/CalliopeStudio/KIDS_BASIC_070 Large.jpeg";
import CalliopeStudio11 from "../images/commercials/CalliopeStudio/KIDS_BASIC_071 Large.jpeg";
import CalliopeStudio12 from "../images/commercials/CalliopeStudio/KIDS_BASIC_072 Large.jpeg";
import CalliopeStudio13 from "../images/commercials/CalliopeStudio/KIDS_BASIC_073 Large.jpeg";
import CalliopeStudio14 from "../images/commercials/CalliopeStudio/KIDS_BASIC_074 Large.jpeg";
import CalliopeStudio15 from "../images/commercials/CalliopeStudio/KIDS_BASIC_075 Large.jpeg";
import CalliopeStudio16 from "../images/commercials/CalliopeStudio/KIDS_BASIC_076 Large.jpeg";
import CalliopeStudio17 from "../images/commercials/CalliopeStudio/KIDS_BASIC_077 Large.jpeg";
import CalliopeStudio18 from "../images/commercials/CalliopeStudio/KIDS_BASIC_078 Large.jpeg";


const CalliopeStudio = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={CalliopeStudio1} alt="Calliope Studio Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio2} alt="Calliope Studio Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio3} alt="Calliope Studio Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio4} alt="Calliope Studio Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio6} alt="Calliope Studio Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio5} alt="Calliope Studio Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio7} alt="Calliope Studio Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio8} alt="Calliope Studio Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio9} alt="Calliope Studio Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio10} alt="Calliope Studio Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio11} alt="Calliope Studio Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio12} alt="Calliope Studio Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio13} alt="Calliope Studio Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio14} alt="Calliope Studio Commercial Photography - Image 14"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio15} alt="Calliope Studio Commercial Photography - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio16} alt="Calliope Studio Commercial Photography - Image 16"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio17} alt="Calliope Studio Commercial Photography - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeStudio18} alt="Calliope Studio Commercial Photography - Image 18"/>
                </div>
            </div>
        </div>
    );
}

export default CalliopeStudio;